import FilterNumber from "@/components/inputs/FilterNumber";
import FilterString from "@/components/inputs/FilterString";
import FilterCalendar from "@/components/inputs/FilterCalendar";
import CustomSelect from "@/components/inputs/CustomSelect";

export const FilterFactory = ({
  filter,
  value,
  onChange,
  statusOptions,
  employeesOptions,
  unitsOptions,
  objectsOptions,
}) => {
  const { type } = filter;

  switch (type) {
    case "number":
      return <FilterNumber fromTo={false} value={value} onSubmit={onChange} />;

    case "text":
      return <FilterString value={value} onSubmit={onChange} />;

    case "date":
      return (
        <FilterCalendar
          fromTo={false}
          value={value}
          type="date"
          onSubmit={onChange}
        />
      );

    case "status":
      return (
        <CustomSelect
          value={value}
          placeholder="Выберите статус"
          options={statusOptions}
          fieldNames={{ value: "uuid", label: "name" }}
          optionFilterProp="name"
          style={{ width: 200 }}
          onChange={onChange}
          allowClear
        />
      );

    case "employee":
      return (
        <CustomSelect
          value={value}
          placeholder="Начните вводить"
          options={employeesOptions}
          optionFilterProp="label"
          style={{ width: 200 }}
          onChange={onChange}
          allowClear
        />
      );

    case "unit":
      return (
        <CustomSelect
          value={value}
          placeholder="Начните вводить"
          options={unitsOptions}
          showSearch
          fieldNames={{ value: "uuid", label: "name" }}
          optionFilterProp="name"
          style={{ width: 200 }}
          onChange={onChange}
          allowClear
        />
      );

    case "object":
      return (
        <CustomSelect
          value={value}
          placeholder="Начните вводить"
          options={objectsOptions || []}
          showSearch
          fieldNames={{ value: "uuid", label: "name" }}
          optionFilterProp="name"
          style={{ width: 200 }}
          onChange={onChange}
          allowClear
        />
      );

    default:
      return <div>{type}</div>;
  }
};
